import { FileUploadWorkerInfo } from "./file-upload-worker-info-model";
import { FileMultipartUploadWorkerInfo } from "./file-multipart-upload-worker-info-model";
import { apolloClient } from "../services/vue-apollo";
import {
    GET_PANORAMA_RAW_ZIP_UPLOAD_URL,
    GET_PANORAMA_RAW_ZIP_MULTIPART_INFO,
    COMPLETE_PANORAMA_RAW_ZIP_MULTIPART,
    PROCESS_PANORAMA_UPLOADED_ZIP,
} from "../graphql/project-layer-queries";

export class PanoramaRawUploadWorkerInfo extends FileUploadWorkerInfo {
    projectId: number;
    scanName: string;
    layerName: string;

    constructor(file: File, projectId: number, scanName: string, layerName: string) {
        super(file);
        this.projectId = projectId;
        this.scanName = scanName;
        this.layerName = layerName;
    }

    startUpload() {
        apolloClient
            .query({
                query: GET_PANORAMA_RAW_ZIP_UPLOAD_URL,
                variables: { projectId: this.projectId, scanName: this.scanName },
                fetchPolicy: "no-cache",
            })
            .then((res) => {
                this.startSinglePartUpload(res.data.getPanoramaRawZipUploadUrl.uploadUrl);
            })
            .catch((ex) => {
                console.error(ex);
                if (this.onError) {
                    this.onError(ex);
                }
            });
    }

    completeUpload() {
        this.onStarted?.(`Upload complete. Lambda is inspecting ZIP...`);
        apolloClient
            .mutate({
                mutation: PROCESS_PANORAMA_UPLOADED_ZIP,
                variables: {
                    projectId: this.projectId,
                    scanName: this.scanName,
                    layerName: this.layerName,
                },
            })
            .then(() => {
                super.completeUpload();
            })
            .catch((ex) => {
                this.progressMonitor.stopProgressMonitoring();
                this.state.setError(ex);
                if (this.onError) {
                    this.onError(ex);
                }
            });
    }
}

export class PanoramaRawMultipartUploadWorkerInfo extends FileMultipartUploadWorkerInfo {
    projectId: number;
    scanName: string;
    layerName: string;

    constructor(file: File, projectId: number, scanName: string, layerName: string) {
        super(file);
        this.projectId = projectId;
        this.scanName = scanName;
        this.layerName = layerName;
    }

    startUpload() {
        apolloClient
            .query({
                query: GET_PANORAMA_RAW_ZIP_MULTIPART_INFO,
                variables: {
                    projectId: this.projectId,
                    scanName: this.scanName,
                    numberOfParts: this.numberOfParts,
                },
                fetchPolicy: "no-cache",
            })
            .then((res) => {
                const info = res.data.getPanoramaRawZipMultipartInfo;
                this.startMultipartUpload({ ...info, filename: this.scanName });
            })
            .catch((ex) => this.handleError(ex, () => this.startUpload()));
    }

    completeMultipartUpload(eTags: string[]) {
        this.onStarted?.(`Upload complete. Lambda is inspecting ZIP...`);

        apolloClient
            .mutate({
                mutation: COMPLETE_PANORAMA_RAW_ZIP_MULTIPART,
                variables: {
                    projectId: this.projectId,
                    scanName: this.scanName,
                    uploadId: this.uploadId,
                    eTags: eTags.join(","),
                },
            })
            .then(() => {
                return apolloClient.mutate({
                    mutation: PROCESS_PANORAMA_UPLOADED_ZIP,
                    variables: {
                        projectId: this.projectId,
                        scanName: this.scanName,
                        layerName: this.layerName,
                    },
                });
            })
            .then(() => {
                this.progressMonitor.setComplete();
                this.state.setComplete();
                if (this.onComplete) this.onComplete();
            })
            .catch((ex) => {
                this.progressMonitor.stopProgressMonitoring();
                this.state.setError(ex);
                if (this.onError) this.onError(ex);
            });
    }
}
